import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import debounce from 'lodash/debounce';

import SupplementaryReportsModal from './SupplementaryReportsModal';
import SupplementaryReportsStore from './SupplementaryReportsStore';
import SupplementaryReportsToolbar from './SupplementaryReportsToolbar';
import SupplementaryReportsTable from './SupplementaryReportsTable';
import ui from '../../../stores/dashboard';
import router from '../../../stores/router';
import * as api from '../../../stores/api';
import moment from 'moment';

@observer
class SupplementaryReports extends React.Component {
  renderCaseForCM = caseStatus => {
    switch (caseStatus) {
      case `Dictations Sent to MAG`:
        return `Dictation Received`;
      case 'Corrected Report Sent to MAG':
        return 'Corrected Report Returned from Provider';
      default:
        return caseStatus;
    }
  };
  componentDidMount() {
    this._searchDebounced();
    // ui.on('open(/view/supplementary-reports-2)', this._searchDebounced);
  }
  _searchDebounced = debounce(() => {
    const { search } = router.location;
    if (search) {
      if (search.indexOf('?actionRequired=') !== -1) {
        const id = search.replace('?actionRequired=', '');
        SupplementaryReportsStore.refetch({ actionRequiredById: id }, true);
      } else if (search.indexOf('?caseStatus=') !== -1 && api.isCaseManager()) {
        const id = search.replace('?caseStatus=', '');
        SupplementaryReportsStore.refetch({ filter: this.renderCaseForCM(id) }, true);
      } else if (search.indexOf('?fromToRequest') !== -1) {
        SupplementaryReportsStore.refetch({ fromTo: `${moment().format('DD/MM/YYYY')} - ` }, true);
      } else {
        const id = search.replace('?nextTaskDue=', '');
        if (api.isCaseManager()) {
          SupplementaryReportsStore.refetch({ filter: this.renderCaseForCM(id) }, true);
        } else {
          SupplementaryReportsStore.refetch({ filterOverdue: id }, true);
        }
      }
    } else {
      SupplementaryReportsStore.refetch({}, true);
    }
  }, 1000);

  render() {
    const {
      loading,
      data,
      open,
      dataClaimant,
      loadingClaimant,
      loadingDynamicSRStatus,
      loadingStaff,
      loadingDynamicOverDueSRStatus,
      loadingStaffAssign,
      loadingStaffAssignAction,
      dataDynamicSupplementaryReportStatus,
      dataDynamicOverDueSupplementaryReportStatus,
      dataStaff,
      dataStaffAssign,
      dataStaffAssignAction,
    } = SupplementaryReportsStore;

    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {(loading && !data) ||
        (!dataClaimant && loadingClaimant) ||
        (loadingDynamicSRStatus && !dataDynamicSupplementaryReportStatus) ||
        (loadingStaff && !dataStaff) ||
        (loadingDynamicOverDueSRStatus && !dataDynamicOverDueSupplementaryReportStatus) ||
        (loadingStaffAssign && !dataStaffAssign) ||
        (loadingStaffAssignAction && !dataStaffAssignAction) ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <SupplementaryReportsToolbar />
            <SupplementaryReportsTable />
            {open && <SupplementaryReportsModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SupplementaryReports;
